export default function keepInInterval(min, max, value) {
  return Math.min(Math.max(min, value), max)
};
